import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/devops-enablement/require_devops.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud p-100 cloud_mig_solution"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Let’s Talk <span>DevOps</span>
            </h2>
            <p>
              Want to start a discussion on how our DevOps Enablement can work
              for you? Sign up now for a FREE Consultation. Let us discover how
              we can enhance your DevOp processes for your specific business
              needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Get A Quote
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
